<div class="row">
  <div class="fulfillmentLanding create-return-outer" (window:resize)="onresize($event)">
    <div class="create-return-page">
      <div class="page-head xs-mt-15">
        <h3 *ngIf="!isReturnTypeForInnoculant" class="d-flex align-items-center">CPP Returns Confirmation</h3>
        <h3 *ngIf="isReturnTypeForInnoculant" class="d-flex align-items-center">Inoculant Returns</h3>
      </div>
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a *ngIf="!isReturnTypeForInnoculant" href="javascript:void(0)" routerLink="/cpp-returns/dashboard-products">CPP Returns</a>
              <a *ngIf="isReturnTypeForInnoculant" href="javascript:void(0)" routerLink="/cpp-returns/dashboard-products/Inoculant">Inoculant Returns</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span>{{breadcrumbtext}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="returnTop xs-mb-5">
        <!--Ship to - Confirmation Email Section-->
        <div>
          <div class="row">
            <div class=" col-md-6 mb-2">
              <label>Sold To: (Will display after selection of Ship To:)</label>
              <div>
                {{soldToaccountName}}
              </div>
              <div> {{soldToaddress}}</div>
              <div class="border-line">
                Account #:{{soldToAcnumber}}
              </div>
            </div>
            <div class=" col-lg-6  mb-2">
              <label>Ship To:</label>
              <div>
                {{shipToAccountName}}
              </div>
              <div>
                {{shipToAddress}}
              </div>
              <div class="border-line">
                Account #:{{shipToAcnumber}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Pickup Information Section-->
      <div class="returnTop xs-mb-0">
        <h6 class="form-group-title">Pickup Information:</h6>
        <div class="row">
          <div class="col-lg-3 col-md-6 xs-mb-15">
            <label>Desired Pickup Date:</label>
            <div>
              {{desiredPickupDate | date:'MM/dd/yyyy'}}
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="xs-mb-15">
              <label>Contact Name:</label>
              <div>
                {{contactName}}
              </div>
            </div>
            <div class="xs-mb-15">
              <label>Contact Number:</label>
              <div>
                {{contactNumber | mask: '000-000-0000' }}
              </div>
            </div>
            <div class="xs-mb-15">
              <label>Customer PO Number:</label>
              <div>
                {{customerPONumber}}
              </div>
            </div>
          </div>
          <div class=" col-lg-3 col-md-6 material-select withBordr">
            <div class="xs-mb-15">
              <label>Pickup Location:</label>
              <div>
                {{deliveryAccountName}}
              </div>
            </div>
            <div class="xs-mb-15">
              <label>Shipping Instructions:</label>
              <div>
                {{shippingInstructions}}
              </div>
            </div>
          </div>
          <div class=" col-lg-3 col-md-6 material-select withBordr">
            <div class="xs-mb-15">
              <label>Freight Instructions:</label>
              <div class="h-50">
                {{selectedFreightInstructionName}}
              </div>
            </div>
            <div class="row no-gutter">
              <div class="col-md-4 xs-mb-15 xs-pl-15">
                <label>Pallet Count:</label>
                <div>
                  {{palletCount}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="returnDetail">
        <!--Product Detail section-->
        <div class="addProdContent">
          <div class="row">
            <div class="col-md-12 margin-t10">
              <div class="productTableOuter">
                <div class="tableContainer prodTableContainer" id="returnRequestView">
                  <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                      <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
                </div>
                <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
                <div *ngIf="column=='itemNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Item Number</th></div>
                <div *ngIf="column=='units'"><th mat-header-cell *matHeaderCellDef class="units text-center">Eligible Units</th></div>
                <div *ngIf="column=='dumpedUnits'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Requested Units</th></div>
                <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>
                <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Package Size</th></div>
                <div *ngIf="column=='notes'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>
                <div *ngIf="column=='approverNotes'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Approver Notes</th></div>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="column=='product'" class="order-info-outer">
                    <div class="order-info">
                      <p class="prod-id">{{element.itemVendorName}}</p>
                      <p class="prod-name">{{element.itemDescription}}</p>
                    </div>
                  </div>
                  <div *ngIf="column=='itemNumber'" class="measureUnit text-center">
                    <p> {{element.itemNumber}} </p>
                  </div>
                  <div *ngIf="column=='units'" class="measureUnit text-center">
                    <p> {{element.eligibleUnit}} </p>
                  </div>
                  <div *ngIf="column=='dumpedUnits'" class="measureUnit text-center">
                    <p> {{element.returnQuantity}} </p>
                  </div>
                  <div *ngIf="column=='uom'" class="measureUnit text-center">
                    <p> {{element.uom}} </p>
                  </div>
                  <div *ngIf="column=='packageSize'" class="measureUnit text-center">
                    <p> {{element.packageSize}} </p>
                  </div>
                  <div *ngIf="column=='notes'" class="measureUnit text-center">
                    <p> {{element.customerNotes}} </p>
                  </div>
                  <div *ngIf="column=='approverNotes'" [ngClass]="{ 'disabledrow': (element.lineStatus =='REJECTED' ) }" class="measureUnit text-center">
                    <textarea id="txtapproverNotes_{{element.itemNumber}}" [disabled]="!element.isShowInoculantWarning" [readonly]="reviewRequestMode || (element.lineStatus =='APPROVED' && requestStatus=='IN EDIT')" type="text" class="notesTxt" [(ngModel)]="element.approverNotes" maxlength="250"></textarea>
                  </div>
                </td>
                </ng-container>
                <ng-container matColumnDef="warningDetail">
                  <td mat-cell class="product-details p-0" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="inline-error-warning" *ngIf="isReturnTypeForInnoculant  && element.isIPConfigured && element.isShowInoculantWarning" id="warning_{{element.itemId}}_{{element.lotNumber}}">
                      <div class="row">
                        <div class="col-md-9">
                          <ol>
                            <li>
                              {{warningMessage}}
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row"
                    [ngStyle]="(!element.isShowInoculantWarning) && {'background-color': 'lightgrey'}"
                    [class.example-expanded-row]="expandedElement === element"></tr>
                <tr mat-row *matRowDef="let row; columns: ['warningDetail']" class="example-detail-row"></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isAccessForApproveReject" class="SeedFulfillBtnSec">
      <div class="row padding-l20">
        <div class="col-md-6">
          <button mat-raised-button class="btns" (click)="approvedJDERequest()" [style.display]="'inline-block'" id="btnSubmitReturn">Approve</button>
          <button mat-raised-button class="btns" color="primary" (click)="rejectedJDERequest()" [style.display]="'inline-block'">Reject</button>
          <button mat-raised-button class="btns" color="primary" (click)="returnToDraft()" [style.display]="'inline-block'">Return to draft</button>
        </div>
        <div class="col-md-6 text-right">
          <span class="count">Returnable Products <span>{{productAllDataSource.data.length}}</span></span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
